export default {"src":"/_next/static/media/dowloadAppStore.9df8c5c5.svg","height":238,"width":800,"blurWidth":0,"blurHeight":0};